import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'fat:theme';

function readInitial() {
  if (typeof document === 'undefined') return 'dark';
  const fromAttr = document.documentElement.getAttribute('data-theme');
  if (fromAttr === 'light' || fromAttr === 'dark') return fromAttr;
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch {
    // ignore
  }
  return 'dark';
}

function apply(theme) {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', theme);
}

/**
 * Estado: 'dark' | 'light'.
 * Persiste em localStorage e aplica em html[data-theme].
 * Sincroniza com o atributo ja aplicado pelo script inline (anti-FOUC).
 */
export function useTheme() {
  const [theme, setTheme] = useState(readInitial);

  // Apply on mount + on change
  useEffect(() => {
    apply(theme);
    try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* ignore */ }
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme(t => (t === 'dark' ? 'light' : 'dark'));
  }, []);

  return { theme, setTheme, toggle };
}
